import React from 'react'
import Top from './Top'
import Reason from './Reason'
import Faq from './Faq'

const Landingpage = () => {
  return (
    <div className='landingparent'>
      <Top />
      <Reason/>
      <Faq/>
    </div>
  )
}

export default Landingpage
